import { NotifierList } from '@site-mate/dashpivot-shared-library';

export interface WorkflowNotificationVariableOption {
  label: string;
  icon: string;
  value: NotifierList;
  hasPopover: boolean;
  popoverLabel: string;
}

export const CreatorVariableOption: Readonly<WorkflowNotificationVariableOption> = {
  label: 'Creator',
  value: NotifierList.Creator,
  icon: 'cc-icon-zap',
  hasPopover: true,
  popoverLabel: 'Select ‘Creator’ to notify the form creator.',
};

export const ContributorsVariableOption: Readonly<WorkflowNotificationVariableOption> = {
  label: 'All Contributors',
  value: NotifierList.Contributors,
  icon: 'cc-icon-zap',
  hasPopover: true,
  popoverLabel: `Select 'All Contributors' to notify all Contributors within this folder.`,
};

export const VisitorsVariableOption: Readonly<WorkflowNotificationVariableOption> = {
  label: 'All Visitors',
  value: NotifierList.Visitors,
  icon: 'cc-icon-zap',
  hasPopover: true,
  popoverLabel: `Select 'All Visitors' to notify all Visitors within this folder.`,
};

export const WorkflowNotificationVariableOptions = [
  CreatorVariableOption,
  ContributorsVariableOption,
  VisitorsVariableOption,
] as const;
